import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './FindPasswordPage.module.css';
import FindIdEasyAuthPanel from './panel/findid/FindIdEasyAuthPanel';
import FindIdSuccessPanel from './panel/findid/FindIdSuccessPanel';
import { DialogEnum, showDialog } from '../../utils/dialog/Dialog';
import axios from "../../utils/api/axios";
import { InnocodeButton } from '@intsoft/innocode-core';

function FindPasswordPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [userId, setUserId] = useState('test@test.com');

  const handleNext = (emailId = '') => {
    setUserId(emailId)
    setStep(2);
  };

  const handleComplete = () => {
    navigate('/login');
  };

  const goBack = () => {
    if (step === 1) {
      navigate('/login');
    } else {
      setStep(step - 1);
    }
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return <FindIdEasyAuthPanel onNext={handleNext} />;
      case 2:
        return <FindIdSuccessPanel onNext={handleComplete} userId={userId} />;
      default:
        return null;
    }
  };

  return (
    <div className="innocode-breakpoint-layout-bg">
      <div className="innocode-breakpoint-content">
      <div className={styles.layout_container}> 
            <header className={styles.header} id="main-header">
              <InnocodeButton enablePadding={false} onClick={() => { navigate(-1); }} designType={'assistive'} theme={'opacity'} iconOnly={true} icon={
                  <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m15 19-7-7 7-7" />
                  </svg>

              }></InnocodeButton>
            </header>
            <div className={styles.content_wrapper}>{renderStep()}</div> 
          </div>
      </div>
    </div>
  );
}

export default FindPasswordPage;
